export default {
  title: 'Programa de reseñas de Google',
  sections: {
    google_review_settings: 'Configuración del programa de reseñas de Google',
  },
  form: {
    reward: {
      label: 'Recompensa (puntos)',
      point_value: '100 puntos = {{moneyValue}}',
    },
    has_end_date: {
      label: 'Duración',
      options: {
        false: 'Indefinido',
        true: 'Con fecha de fin específica',
      },
    },
    end_date: {
      label: 'Fecha de fin',
    },
  },
  tags: {
    inactive: 'No activo',
    active: 'Activo',
    expired: 'Caducado',
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
    changes_got_saved: 'Los cambios se han guardado',
    failed_to_save_changes: 'Error al guardar los cambios',
  },
};
